
      import UpDownStructure from './up-down-structure.vue'
      import type { App, Plugin } from 'vue'

      export const UpDownStructurePlugin: Plugin = {
        install(app: App) {
          app.component('UpDownStructure', UpDownStructure)
        },
      }
      export { UpDownStructure }
      